__turbopack_context__.v({
  "className": "fWdLaG_className",
});
